(function (RecTool, $) {
  var $recommender = $('.product-recommender--wrapper');
  var hairstyle = '',
      hairshine = '',
      holdfactor = '';

  RecTool.skus = [
    /** Product: "Reuzel Blue Pomade" */
    {
      hairstyle: "CURLY", hairshine: "HIGH", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Blue Pomade", subtitle: "STRONG HOLD – HIGH SHINE – WATER SOLUBLE", url: "/products/blue-pomade-strong-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/StrongHoldWaterSoluble.jpg?v=1578605590", selected: "REU011", 
        variants: [
          {id: 27861333442640, SKU: "REU012", title: "12oz/340g", price: "38.00"},
          {id: 27861333409872, SKU: "REU011", title: "4oz/113g", price: "17.00"},
          {id: 27861333344336, SKU: "REU010", title: "1.3oz/35g", price: "8.50"},
        ]
      },
    },
    {
      hairstyle: "POMPADOUR", hairshine: "HIGH", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Blue Pomade", subtitle: "STRONG HOLD – HIGH SHINE – WATER SOLUBLE", url: "/products/blue-pomade-strong-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/StrongHoldWaterSoluble.jpg?v=1578605590", selected: "REU011", 
        variants: [
          {id: 27861333442640, SKU: "REU012", title: "12oz/340g", price: "38.00"},
          {id: 27861333409872, SKU: "REU011", title: "4oz/113g", price: "17.00"},
          {id: 27861333344336, SKU: "REU010", title: "1.3oz/35g", price: "8.50"},
        ]
      },
    },
    {
      hairstyle: "POMPADOUR", hairshine: "HIGH", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Blue Pomade", subtitle: "STRONG HOLD – HIGH SHINE – WATER SOLUBLE", url: "/products/blue-pomade-strong-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/StrongHoldWaterSoluble.jpg?v=1578605590", selected: "REU011", 
        variants: [
          {id: 27861333442640, SKU: "REU012", title: "12oz/340g", price: "38.00"},
          {id: 27861333409872, SKU: "REU011", title: "4oz/113g", price: "17.00"},
          {id: 27861333344336, SKU: "REU010", title: "1.3oz/35g", price: "8.50"},
        ]
      },
    },
    {
      hairstyle: "SLICK", hairshine: "HIGH", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Blue Pomade", subtitle: "STRONG HOLD – HIGH SHINE – WATER SOLUBLE", url: "/products/blue-pomade-strong-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/StrongHoldWaterSoluble.jpg?v=1578605590", selected: "REU011", 
        variants: [
          {id: 27861333442640, SKU: "REU012", title: "12oz/340g", price: "38.00"},
          {id: 27861333409872, SKU: "REU011", title: "4oz/113g", price: "17.00"},
          {id: 27861333344336, SKU: "REU010", title: "1.3oz/35g", price: "8.50"},
        ]
      },
    },
    {
      hairstyle: "SIDE PART", hairshine: "HIGH", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Blue Pomade", subtitle: "STRONG HOLD – HIGH SHINE – WATER SOLUBLE", url: "/products/blue-pomade-strong-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/StrongHoldWaterSoluble.jpg?v=1578605590", selected: "REU011", 
        variants: [
          {id: 27861333442640, SKU: "REU012", title: "12oz/340g", price: "38.00"},
          {id: 27861333409872, SKU: "REU011", title: "4oz/113g", price: "17.00"},
          {id: 27861333344336, SKU: "REU010", title: "1.3oz/35g", price: "8.50"},
        ]
      },
    },
    {
      hairstyle: "TEXTURE", hairshine: "HIGH", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Blue Pomade", subtitle: "STRONG HOLD – HIGH SHINE – WATER SOLUBLE", url: "/products/blue-pomade-strong-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/StrongHoldWaterSoluble.jpg?v=1578605590", selected: "REU011", 
        variants: [
          {id: 27861333442640, SKU: "REU012", title: "12oz/340g", price: "38.00"},
          {id: 27861333409872, SKU: "REU011", title: "4oz/113g", price: "17.00"},
          {id: 27861333344336, SKU: "REU010", title: "1.3oz/35g", price: "8.50"},
        ]
      },
    },
    {
      hairstyle: "SPIKEY", hairshine: "HIGH", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Blue Pomade", subtitle: "STRONG HOLD – HIGH SHINE – WATER SOLUBLE", url: "/products/blue-pomade-strong-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/StrongHoldWaterSoluble.jpg?v=1578605590", selected: "REU011", 
        variants: [
          {id: 27861333442640, SKU: "REU012", title: "12oz/340g", price: "38.00"},
          {id: 27861333409872, SKU: "REU011", title: "4oz/113g", price: "17.00"},
          {id: 27861333344336, SKU: "REU010", title: "1.3oz/35g", price: "8.50"},
        ]
      },
    },
    {
      hairstyle: "MESSY", hairshine: "HIGH", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Blue Pomade", subtitle: "STRONG HOLD – HIGH SHINE – WATER SOLUBLE", url: "/products/blue-pomade-strong-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/StrongHoldWaterSoluble.jpg?v=1578605590", selected: "REU011", 
        variants: [
          {id: 27861333442640, SKU: "REU012", title: "12oz/340g", price: "38.00"},
          {id: 27861333409872, SKU: "REU011", title: "4oz/113g", price: "17.00"},
          {id: 27861333344336, SKU: "REU010", title: "1.3oz/35g", price: "8.50"},
        ]
      },
    },
    {
      hairstyle: "?", hairshine: "HIGH", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Blue Pomade", subtitle: "STRONG HOLD – HIGH SHINE – WATER SOLUBLE", url: "/products/blue-pomade-strong-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/StrongHoldWaterSoluble.jpg?v=1578605590", selected: "REU011", 
        variants: [
          {id: 27861333442640, SKU: "REU012", title: "12oz/340g", price: "38.00"},
          {id: 27861333409872, SKU: "REU011", title: "4oz/113g", price: "17.00"},
          {id: 27861333344336, SKU: "REU010", title: "1.3oz/35g", price: "8.50"},
        ]
      },
    },
    
    /** Product: "Clay Matte Pomade" */
    {
      hairstyle: "POMPADOUR", hairshine: "LOW", holdfactor: "MEDIUM",
      recommendation1: { title: "Clay Matte Pomade", subtitle: "MEDIUM HOLD – NO SHINE – WATER SOLUBLE", url: "/products/clay-matte-pomade-strong-hold-matte-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClayMattePomade.jpg?v=1627933695", selected: "REU033",
        variants: [
          {id: 27861335343184, SKU: "REU032", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335310416, SKU: "REU033", title: "4oz/113g", price: "18.00"},
          {id: 27861335277648, SKU: "REU034", title: "12oz/340g", price: "39.00"},
        ]
      },
    },
    {
      hairstyle: "SLICK", hairshine: "LOW", holdfactor: "MEDIUM",
      recommendation1: { title: "Clay Matte Pomade", subtitle: "MEDIUM HOLD – NO SHINE – WATER SOLUBLE", url: "/products/clay-matte-pomade-strong-hold-matte-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClayMattePomade.jpg", selected: "REU033",
        variants: [
          {id: 27861335343184, SKU: "REU032", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335310416, SKU: "REU033", title: "4oz/113g", price: "18.00"},
          {id: 27861335277648, SKU: "REU034", title: "12oz/340g", price: "39.00"},
        ]
      },
      recommendation2: { title: "Matte Styling Paste", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/matte-styling-paste-3-38oz-100ml", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteStylingPaste.jpg?v=1578605343", selected: "REU067", 
        variants: [
          {id: 30274287927376, SKU: "REU067", title: "Matte Styling Paste - 3.38oz/100ml", price: "13.95"},
        ]
      },
    },
    {
      hairstyle: "SIDE PART", hairshine: "LOW", holdfactor: "MEDIUM",
      recommendation1: { title: "Clay Matte Pomade", subtitle: "MEDIUM HOLD – NO SHINE – WATER SOLUBLE", url: "/products/clay-matte-pomade-strong-hold-matte-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClayMattePomade.jpg", selected: "REU033",
        variants: [
          {id: 27861335343184, SKU: "REU032", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335310416, SKU: "REU033", title: "4oz/113g", price: "18.00"},
          {id: 27861335277648, SKU: "REU034", title: "12oz/340g", price: "39.00"},
        ]
      },
      recommendation2: { title: "Fiber Cream", ubtitle: "MEDIUM, PLIABLE HOLD - LOW SHINE - WATER SOLUBLE", url: "/products/reu073", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberCream_1296x_52cb3039-0b88-4095-a133-63abe1b8ea17.jpg", selected: "REU073", 
        variants: [
          {id: 32166859407440, SKU: "REU073", title: "REU073", price: "14.95"},
        ]
      },
    },
    {
      hairstyle: "TEXTURE", hairshine: "LOW", holdfactor: "STRONG",
      recommendation1: { title: "Clay Matte Pomade", subtitle: "MEDIUM HOLD – NO SHINE – WATER SOLUBLE", url: "/products/clay-matte-pomade-strong-hold-matte-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClayMattePomade.jpg", selected: "REU033",
        variants: [
          {id: 27861335343184, SKU: "REU032", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335310416, SKU: "REU033", title: "4oz/113g", price: "18.00"},
          {id: 27861335277648, SKU: "REU034", title: "12oz/340g", price: "39.00"},
        ]
      },
      recommendation2: { title: "Matte Styling Paste", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/matte-styling-paste-3-38oz-100ml", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteStylingPaste.jpg?v=1578605343", selected: "REU067", 
        variants: [
          {id: 30274287927376, SKU: "REU067", title: "Matte Styling Paste - 3.38oz/100ml", price: "13.95"},
        ]
      },
    },
    {
      hairstyle: "SPIKEY", hairshine: "LOW", holdfactor: "MEDIUM",
      recommendation1: { title: "Clay Matte Pomade", subtitle: "MEDIUM HOLD – NO SHINE – WATER SOLUBLE", url: "/products/clay-matte-pomade-strong-hold-matte-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClayMattePomade.jpg", selected: "REU033",
        variants: [
          {id: 27861335343184, SKU: "REU032", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335310416, SKU: "REU033", title: "4oz/113g", price: "18.00"},
          {id: 27861335277648, SKU: "REU034", title: "12oz/340g", price: "39.00"},
        ]
      },
    },
    {
      hairstyle: "MESSY", hairshine: "LOW", holdfactor: "STRONG",
      recommendation1: { title: "Clay Matte Pomade", subtitle: "MEDIUM HOLD – NO SHINE – WATER SOLUBLE", url: "/products/clay-matte-pomade-strong-hold-matte-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClayMattePomade.jpg", selected: "REU033",
        variants: [
          {id: 27861335343184, SKU: "REU032", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335310416, SKU: "REU033", title: "4oz/113g", price: "18.00"},
          {id: 27861335277648, SKU: "REU034", title: "12oz/340g", price: "39.00"},
        ]
      },
    },
    {
      hairstyle: "?", hairshine: "LOW", holdfactor: "MEDIUM",
      recommendation1: { title: "Clay Matte Pomade", subtitle: "MEDIUM HOLD – NO SHINE – WATER SOLUBLE", url: "/products/clay-matte-pomade-strong-hold-matte-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClayMattePomade.jpg", selected: "REU033",
        variants: [
          {id: 27861335343184, SKU: "REU032", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335310416, SKU: "REU033", title: "4oz/113g", price: "18.00"},
          {id: 27861335277648, SKU: "REU034", title: "12oz/340g", price: "39.00"},
        ]
      },
      recommendation2: { title: "Matte Styling Paste", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/matte-styling-paste-3-38oz-100ml", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteStylingPaste.jpg?v=1578605343", selected: "REU067", 
        variants: [
          {id: 30274287927376, SKU: "REU067", title: "Matte Styling Paste - 3.38oz/100ml", price: "13.95"},
        ]
      },
    },

    /** Product: "Clay Spray" */
    {
      hairstyle: "CURLY", hairshine: "LOW", holdfactor: "MEDIUM",
      recommendation1: { title: "Clay Spray", subtitle: "Clay Spray", url: "/products/reu074", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClaySpray_1296x_9bd269d3-6335-4141-962b-8464f675dba5.jpg", selected: "REU074", 
        variants: [
          {id: 32735586156624, SKU: "REU074", title: "Clay Spray", price: "20.00"},
        ]
      },
    },
    {
      hairstyle: "LONG", hairshine: "LOW", holdfactor: "MEDIUM",
      recommendation1: { title: "Clay Spray", subtitle: "Clay Spray", url: "/products/reu074", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClaySpray_1296x_9bd269d3-6335-4141-962b-8464f675dba5.jpg", selected: "REU074", 
        variants: [
          {id: 32735586156624, SKU: "REU074", title: "Clay Spray", price: "20.00"},
        ]
      },
      recommendation2: { title: "Matte Texture Powder", subtitle: "VOLUME - TEXTURE - NO SHINE", url: "/products/matte-texture-powder-0-53oz-15g", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteTexturePowder.jpg?v=1578605375", selected: "REU068", 
        variants: [
          {id: 30274290712656, SKU: "REU068", title: "Matte Texture Powder - 0.53oz/15g", price: "18.00"},
        ]
      },
    },
    {
      hairstyle: "MESSY", hairshine: "MEDIUM", holdfactor: "LIGHT",
      recommendation1: { title: "Clay Spray", subtitle: "Clay Spray", url: "/products/reu074", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClaySpray_1296x_9bd269d3-6335-4141-962b-8464f675dba5.jpg", selected: "REU074", 
        variants: [
          {id: 32735586156624, SKU: "REU074", title: "Clay Spray", price: "20.00"},
        ]
      },
    },
    {
      hairstyle: "?", hairshine: "MEDIUM", holdfactor: "LIGHT",
      recommendation1: { title: "Clay Spray", subtitle: "Clay Spray", url: "/products/reu074", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClaySpray_1296x_9bd269d3-6335-4141-962b-8464f675dba5.jpg", selected: "REU074", 
        variants: [
          {id: 32735586156624, SKU: "REU074", title: "Clay Spray", price: "20.00"},
        ]
      },
    },

    /** Product: "Reuzel Extreme Hold Matte Pomade" */
    {
      hairstyle: "CURLY", hairshine: "LOW", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Extreme Hold Matte Pomade", subtitle: "EXTREME HOLD – NO SHINE – WATER SOLUBLE", url: "/products/reuzel-extreme-hold-matte-pomade", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ExtremeHoldMattePomade.jpg?v=1578604905", selected: "REU046", 
        variants: [
          {id: 27861337440336, SKU: "REU045", title: "1.3oz/35g", price: "10.00"},
          {id: 27861337473104, SKU: "REU046", title: "4oz/113g", price: "19.00"},
          {id: 27861337505872, SKU: "REU047", title: "12oz/340g", price: "40.00"},
        ]
      },
    },
    {
      hairstyle: "POMPADOUR", hairshine: "LOW", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Extreme Hold Matte Pomade", subtitle: "EXTREME HOLD – NO SHINE – WATER SOLUBLE", url: "/products/reuzel-extreme-hold-matte-pomade", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ExtremeHoldMattePomade.jpg?v=1578604905", selected: "REU046", 
        variants: [
          {id: 27861337440336, SKU: "REU045", title: "1.3oz/35g", price: "10.00"},
          {id: 27861337473104, SKU: "REU046", title: "4oz/113g", price: "19.00"},
          {id: 27861337505872, SKU: "REU047", title: "12oz/340g", price: "40.00"},
        ]
      },
    },
    {
      hairstyle: "SLICK", hairshine: "LOW", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Extreme Hold Matte Pomade", subtitle: "EXTREME HOLD – NO SHINE – WATER SOLUBLE", url: "/products/reuzel-extreme-hold-matte-pomade", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ExtremeHoldMattePomade.jpg?v=1578604905", selected: "REU046", 
        variants: [
          {id: 27861337440336, SKU: "REU045", title: "1.3oz/35g", price: "10.00"},
          {id: 27861337473104, SKU: "REU046", title: "4oz/113g", price: "19.00"},
          {id: 27861337505872, SKU: "REU047", title: "12oz/340g", price: "40.00"},
        ]
      },
    },
    {
      hairstyle: "SIDE PART", hairshine: "LOW", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Extreme Hold Matte Pomade", subtitle: "EXTREME HOLD – NO SHINE – WATER SOLUBLE", url: "/products/reuzel-extreme-hold-matte-pomade", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ExtremeHoldMattePomade.jpg?v=1578604905", selected: "REU046", 
        variants: [
          {id: 27861337440336, SKU: "REU045", title: "1.3oz/35g", price: "10.00"},
          {id: 27861337473104, SKU: "REU046", title: "4oz/113g", price: "19.00"},
          {id: 27861337505872, SKU: "REU047", title: "12oz/340g", price: "40.00"},
        ]
      },
    },
    {
      hairstyle: "SIDE PART", hairshine: "MEDIUM", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Extreme Hold Matte Pomade", subtitle: "EXTREME HOLD – NO SHINE – WATER SOLUBLE", url: "/products/reuzel-extreme-hold-matte-pomade", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ExtremeHoldMattePomade.jpg?v=1578604905", selected: "REU046", 
        variants: [
          {id: 27861337440336, SKU: "REU045", title: "1.3oz/35g", price: "10.00"},
          {id: 27861337473104, SKU: "REU046", title: "4oz/113g", price: "19.00"},
          {id: 27861337505872, SKU: "REU047", title: "12oz/340g", price: "40.00"},
        ]
      },
      recommendation2: { title: "Reuzel Pink Pomade", subtitle: "STRONG HOLD - MEDIUM SHINE - OIL BASED", url: "/products/pink-pomade-heavy-hold-medium-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/Reuzel__Pink_Pomade_4oz_113g.jpg?v=1578605116", selected: "REU003", 
        variants: [
          {id: 27861333016656, SKU: "REU008", title: "1.3oz/35g", price: "8.50"},
          {id: 27861333049424, SKU: "REU003", title: "4oz/113g", price: "17.00"},
          {id: 27861333082192, SKU: "REU009", title: "12oz/340g", price: "38.00"},
        ]
      },
    },
    {
      hairstyle: "SPIKEY", hairshine: "LOW", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Extreme Hold Matte Pomade", subtitle: "EXTREME HOLD – NO SHINE – WATER SOLUBLE", url: "/products/reuzel-extreme-hold-matte-pomade", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ExtremeHoldMattePomade.jpg?v=1578604905", selected: "REU046", 
        variants: [
          {id: 27861337440336, SKU: "REU045", title: "1.3oz/35g", price: "10.00"},
          {id: 27861337473104, SKU: "REU046", title: "4oz/113g", price: "19.00"},
          {id: 27861337505872, SKU: "REU047", title: "12oz/340g", price: "40.00"},
        ]
      },
    },
    {
      hairstyle: "SPIKEY", hairshine: "MEDIUM", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Extreme Hold Matte Pomade", subtitle: "EXTREME HOLD – NO SHINE – WATER SOLUBLE", url: "/products/reuzel-extreme-hold-matte-pomade", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ExtremeHoldMattePomade.jpg?v=1578604905", selected: "REU046", 
        variants: [
          {id: 27861337440336, SKU: "REU045", title: "1.3oz/35g", price: "10.00"},
          {id: 27861337473104, SKU: "REU046", title: "4oz/113g", price: "19.00"},
          {id: 27861337505872, SKU: "REU047", title: "12oz/340g", price: "40.00"},
        ]
      },
    },

    /** Product: "Fiber Cream" */
    {
      hairstyle: "CURLY", hairshine: "MEDIUM", holdfactor: "MEDIUM",
      recommendation1: { title: "Fiber Cream", subtitle: "MEDIUM, PLIABLE HOLD - LOW SHINE - WATER SOLUBLE", url: "/products/reu073", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberCream_1296x_52cb3039-0b88-4095-a133-63abe1b8ea17.jpg", selected: "REU073", 
        variants: [
          {id: 32166859407440, SKU: "REU073", title: "REU073", price: "14.95"},
        ]
      },
      recommendation2: { title: "Reuzel Green Pomade", subtitle: "MEDIUM HOLD – MEDIUM SHINE – OIL BASED", url: "/products/green-pomade-medium-hold-medium-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/Reuzel__Green_Pomade_4oz_113g.jpg?v=1578605147", selected: "REU002", 
        variants: [
          {id: 27861330755664, SKU: "REU006", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330788432, SKU: "REU002", title: "4oz/113g", price: "16.00"},
          {id: 27861330821200, SKU: "REU007", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "SLICK", hairshine: "MEDIUM", holdfactor: "LIGHT",
      recommendation1: { title: "Fiber Cream", subtitle: "MEDIUM, PLIABLE HOLD - LOW SHINE - WATER SOLUBLE", url: "/products/reu073", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberCream_1296x_52cb3039-0b88-4095-a133-63abe1b8ea17.jpg", selected: "REU073", 
        variants: [
          {id: 32166859407440, SKU: "REU073", title: "REU073", price: "14.95"},
        ]
      },
    },
    {
      hairstyle: "SLICK", hairshine: "MEDIUM", holdfactor: "MEDIUM",
      recommendation1: { title: "Fiber Cream", subtitle: "MEDIUM, PLIABLE HOLD - LOW SHINE - WATER SOLUBLE", url: "/products/reu073", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberCream_1296x_52cb3039-0b88-4095-a133-63abe1b8ea17.jpg", selected: "REU073", 
        variants: [
          {id: 32166859407440, SKU: "REU073", title: "REU073", price: "14.95"},
        ]
      },
      recommendation2: { title: "Reuzel Green Pomade", subtitle: "MEDIUM HOLD – MEDIUM SHINE – OIL BASED", url: "/products/green-pomade-medium-hold-medium-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/Reuzel__Green_Pomade_4oz_113g.jpg?v=1578605147", selected: "REU002", 
        variants: [
          {id: 27861330755664, SKU: "REU006", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330788432, SKU: "REU002", title: "4oz/113g", price: "16.00"},
          {id: 27861330821200, SKU: "REU007", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "SIDE PART", hairshine: "MEDIUM", holdfactor: "LIGHT",
      recommendation1: { title: "Fiber Cream", subtitle: "MEDIUM, PLIABLE HOLD - LOW SHINE - WATER SOLUBLE", url: "/products/reu073", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberCream_1296x_52cb3039-0b88-4095-a133-63abe1b8ea17.jpg", selected: "REU073", 
        variants: [
          {id: 32166859407440, SKU: "REU073", title: "REU073", price: "14.95"},
        ]
      },
    },
    {
      hairstyle: "LONG", hairshine: "LOW", holdfactor: "STRONG",
      recommendation1: { title: "Fiber Cream", subtitle: "MEDIUM, PLIABLE HOLD - LOW SHINE - WATER SOLUBLE", url: "/products/reu073", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberCream_1296x_52cb3039-0b88-4095-a133-63abe1b8ea17.jpg", selected: "REU073", 
        variants: [
          {id: 32166859407440, SKU: "REU073", title: "REU073", price: "14.95"},
        ]
      },
      recommendation2: { title: "Matte Texture Powder", subtitle: "VOLUME - TEXTURE - NO SHINE", url: "/products/matte-texture-powder-0-53oz-15g", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteTexturePowder.jpg?v=1578605375", selected: "REU068", 
        variants: [
          {id: 30274290712656, SKU: "REU068", title: "Matte Texture Powder - 0.53oz/15g", price: "18.00"},
        ]
      },
    },
    {
      hairstyle: "LONG", hairshine: "MEDIUM", holdfactor: "MEDIUM",
      recommendation1: { title: "Fiber Cream", subtitle: "MEDIUM, PLIABLE HOLD - LOW SHINE - WATER SOLUBLE", url: "/products/reu073", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberCream_1296x_52cb3039-0b88-4095-a133-63abe1b8ea17.jpg", selected: "REU073", 
        variants: [
          {id: 32166859407440, SKU: "REU073", title: "REU073", price: "14.95"},
        ]
      },
    },
    {
      hairstyle: "MESSY", hairshine: "MEDIUM", holdfactor: "MEDIUM",
      recommendation1: { title: "Fiber Cream", subtitle: "MEDIUM, PLIABLE HOLD - LOW SHINE - WATER SOLUBLE", url: "/products/reu073", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberCream_1296x_52cb3039-0b88-4095-a133-63abe1b8ea17.jpg", selected: "REU073", 
        variants: [
          {id: 32166859407440, SKU: "REU073", title: "REU073", price: "14.95"},
        ]
      },
    },
    {
      hairstyle: "?", hairshine: "MEDIUM", holdfactor: "MEDIUM",
      recommendation1: { title: "Fiber Cream", subtitle: "MEDIUM, PLIABLE HOLD - LOW SHINE - WATER SOLUBLE", url: "/products/reu073", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberCream_1296x_52cb3039-0b88-4095-a133-63abe1b8ea17.jpg", selected: "REU073", 
        variants: [
          {id: 32166859407440, SKU: "REU073", title: "REU073", price: "14.95"},
        ]
      },
    },

    /** Product: "Reuzel Fiber Gel" */
    {
      hairstyle: "CURLY", hairshine: "MEDIUM", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Fiber Gel", subtitle: "FIRM, PLIABLE - LOW SHINE - WATER SOLUBLE", url: "/products/fiber-gel-firm-hold", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberGel.jpg?v=1578605048", selected: "REU048", 
        variants: [
          {id: 27861336064080, SKU: "REU048", title: "6.67oz/200ml", price: "19.95"},
          {id: 27861336031312, SKU: "REU041", title: "3.38oz/100ml", price: "12.95"},
        ]
      },
      recommendation2: { title: "Reuzel Pink Pomade", subtitle: "STRONG HOLD - MEDIUM SHINE - OIL BASED", url: "/products/pink-pomade-heavy-hold-medium-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/Reuzel__Pink_Pomade_4oz_113g.jpg?v=1578605116", selected: "REU003", 
        variants: [
          {id: 27861333016656, SKU: "REU008", title: "1.3oz/35g", price: "8.50"},
          {id: 27861333049424, SKU: "REU003", title: "4oz/113g", price: "17.00"},
          {id: 27861333082192, SKU: "REU009", title: "12oz/340g", price: "38.00"},
        ]
      },
    },
    {
      hairstyle: "TEXTURE", hairshine: "MEDIUM", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Fiber Gel", subtitle: "FIRM, PLIABLE - LOW SHINE - WATER SOLUBLE", url: "/products/fiber-gel-firm-hold", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberGel.jpg?v=1578605048", selected: "REU048", 
        variants: [
          {id: 27861336064080, SKU: "REU048", title: "6.67oz/200ml", price: "19.95"},
          {id: 27861336031312, SKU: "REU041", title: "3.38oz/100ml", price: "12.95"},
        ]
      },
    },
    {
      hairstyle: "LONG", hairshine: "MEDIUM", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Fiber Gel", subtitle: "FIRM, PLIABLE - LOW SHINE - WATER SOLUBLE", url: "/products/fiber-gel-firm-hold", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberGel.jpg?v=1578605048", selected: "REU048", 
        variants: [
          {id: 27861336064080, SKU: "REU048", title: "6.67oz/200ml", price: "19.95"},
          {id: 27861336031312, SKU: "REU041", title: "3.38oz/100ml", price: "12.95"},
        ]
      },
    },
    {
      hairstyle: "SPIKEY", hairshine: "MEDIUM", holdfactor: "LIGHT",
      recommendation1: { title: "Reuzel Fiber Gel", subtitle: "FIRM, PLIABLE - LOW SHINE - WATER SOLUBLE", url: "/products/fiber-gel-firm-hold", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberGel.jpg?v=1578605048", selected: "REU048", 
        variants: [
          {id: 27861336064080, SKU: "REU048", title: "6.67oz/200ml", price: "19.95"},
          {id: 27861336031312, SKU: "REU041", title: "3.38oz/100ml", price: "12.95"},
        ]
      },
    },

    /** Product: "Reuzel Fiber Pomade" */
    {
      hairstyle: "POMPADOUR", hairshine: "MEDIUM", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Fiber Pomade", subtitle: "FIRM AND PLIABLE – LOW SHINE – WATER SOLUBLE", url: "/products/fiber-pomade-pliable-hold-natural-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberPomade.jpg", selected: "REU030", 
        variants: [
          {id: 27861335572560, SKU: "REU029", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335539792, SKU: "REU030", title: "4oz/113g", price: "18.00"},
          {id: 27861335507024, SKU: "REU031", title: "12oz/340g", price: "39.00"},
        ]
      },
    },
    {
      hairstyle: "POMPADOUR", hairshine: "MEDIUM", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Fiber Pomade", subtitle: "FIRM AND PLIABLE – LOW SHINE – WATER SOLUBLE", url: "/products/fiber-pomade-pliable-hold-natural-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberPomade.jpg", selected: "REU030", 
        variants: [
          {id: 27861335572560, SKU: "REU029", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335539792, SKU: "REU030", title: "4oz/113g", price: "18.00"},
          {id: 27861335507024, SKU: "REU031", title: "12oz/340g", price: "39.00"},
        ]
      },
      recommendation2: { title: "Reuzel Pink Pomade", subtitle: "STRONG HOLD - MEDIUM SHINE - OIL BASED", url: "/products/pink-pomade-heavy-hold-medium-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/Reuzel__Pink_Pomade_4oz_113g.jpg?v=1578605116", selected: "REU003", 
        variants: [
          {id: 27861333016656, SKU: "REU008", title: "1.3oz/35g", price: "8.50"},
          {id: 27861333049424, SKU: "REU003", title: "4oz/113g", price: "17.00"},
          {id: 27861333082192, SKU: "REU009", title: "12oz/340g", price: "38.00"},
        ]
      },
    },
    {
      hairstyle: "SIDE PART", hairshine: "MEDIUM", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Fiber Pomade", subtitle: "FIRM AND PLIABLE – LOW SHINE – WATER SOLUBLE", url: "/products/fiber-pomade-pliable-hold-natural-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberPomade.jpg", selected: "REU030", 
        variants: [
          {id: 27861335572560, SKU: "REU029", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335539792, SKU: "REU030", title: "4oz/113g", price: "18.00"},
          {id: 27861335507024, SKU: "REU031", title: "12oz/340g", price: "39.00"},
        ]
      },
      recommendation2: { title: "Reuzel Green Pomade", subtitle: "MEDIUM HOLD – MEDIUM SHINE – OIL BASED", url: "/products/green-pomade-medium-hold-medium-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/Reuzel__Green_Pomade_4oz_113.jpg?v=1578605147", selected: "REU002", 
        variants: [
          {id: 27861330755664, SKU: "REU006", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330788432, SKU: "REU002", title: "4oz/113g", price: "16.00"},
          {id: 27861330821200, SKU: "REU007", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "TEXTURE", hairshine: "MEDIUM", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Fiber Pomade", subtitle: "FIRM AND PLIABLE – LOW SHINE – WATER SOLUBLE", url: "/products/fiber-pomade-pliable-hold-natural-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberPomade.jpg", selected: "REU030", 
        variants: [
          {id: 27861335572560, SKU: "REU029", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335539792, SKU: "REU030", title: "4oz/113g", price: "18.00"},
          {id: 27861335507024, SKU: "REU031", title: "12oz/340g", price: "39.00"},
        ]
      },
    },
    {
      hairstyle: "SPIKEY", hairshine: "MEDIUM", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Fiber Pomade", subtitle: "FIRM AND PLIABLE – LOW SHINE – WATER SOLUBLE", url: "/products/fiber-pomade-pliable-hold-natural-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberPomade.jpg", selected: "REU030", 
        variants: [
          {id: 27861335572560, SKU: "REU029", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335539792, SKU: "REU030", title: "4oz/113g", price: "18.00"},
          {id: 27861335507024, SKU: "REU031", title: "12oz/340g", price: "39.00"},
        ]
      },
    },
    {
      hairstyle: "MESSY", hairshine: "MEDIUM", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Fiber Pomade", subtitle: "FIRM AND PLIABLE – LOW SHINE – WATER SOLUBLE", url: "/products/fiber-pomade-pliable-hold-natural-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberPomade.jpg", selected: "REU030", 
        variants: [
          {id: 27861335572560, SKU: "REU029", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335539792, SKU: "REU030", title: "4oz/113g", price: "18.00"},
          {id: 27861335507024, SKU: "REU031", title: "12oz/340g", price: "39.00"},
        ]
      },
    },
    {
      hairstyle: "?", hairshine: "MEDIUM", holdfactor: "STRONG",
      recommendation1: { title: "Reuzel Fiber Pomade", subtitle: "FIRM AND PLIABLE – LOW SHINE – WATER SOLUBLE", url: "/products/fiber-pomade-pliable-hold-natural-finish", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberPomade.jpg", selected: "REU030", 
        variants: [
          {id: 27861335572560, SKU: "REU029", title: "1.3oz/35g", price: "9.50"},
          {id: 27861335539792, SKU: "REU030", title: "4oz/113g", price: "18.00"},
          {id: 27861335507024, SKU: "REU031", title: "12oz/340g", price: "39.00"},
        ]
      },
      recommendation2: { title: "Reuzel Fiber Gel", subtitle: "FIRM, PLIABLE - LOW SHINE - WATER SOLUBLE", url: "/products/fiber-gel-firm-hold", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/FiberGel.jpg?v=1578605048", selected: "REU048", 
        variants: [
          {id: 27861336064080, SKU: "REU048", title: "6.67oz/200ml", price: "19.95"},
          {id: 27861336031312, SKU: "REU041", title: "3.38oz/100ml", price: "12.95"},
        ]
      },
    },

    /** Product: "Grooming Cream" */
    {
      hairstyle: "CURLY", hairshine: "MEDIUM", holdfactor: "LIGHT",
      recommendation1: { title: "Grooming Cream", subtitle: "Light Hold Low Shine Water Soluble", url: "/products/reu066", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/GroomingCream.jpg?v=1578605175", selected: "REU066", 
        variants: [
          {id: 30274287796304, SKU: "REU066", title: "REU066", price: "12.95"},
        ]
      },
    },
    {
      hairstyle: "POMPADOUR", hairshine: "MEDIUM", holdfactor: "LIGHT",
      recommendation1: { title: "Grooming Cream", subtitle: "Light Hold Low Shine Water Soluble", url: "/products/reu066", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/GroomingCream.jpg?v=1578605175", selected: "REU066", 
        variants: [
          {id: 30274287796304, SKU: "REU066", title: "REU066", price: "12.95"},
        ]
      },
    },
    {
      hairstyle: "TEXTURE", hairshine: "MEDIUM", holdfactor: "LIGHT",
      recommendation1: { title: "Grooming Cream", subtitle: "Light Hold Low Shine Water Soluble", url: "/products/reu066", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/GroomingCream.jpg?v=1578605175", selected: "REU066", 
        variants: [
          {id: 30274287796304, SKU: "REU066", title: "REU066", price: "12.95"},
        ]
      },
    },

    /** Product: "Reuzel Grooming Tonic" */
    {
      hairstyle: "CURLY", hairshine: "HIGH", holdfactor: "LIGHT",
      recommendation1: { title: "Reuzel Grooming Tonic", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/reuzel-grooming-tonic", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/GroomingTonic.jpg?v=1578605254", selected: "REU016", 
        variants: [
          {id: 27861333672016, SKU: "REU016", title: "11.83oz / 350ml", price: "18.00"},
          {id: 27861333639248, SKU: "REU035", title: "3.38oz / 100ml", price: "7.00"},
          {id: 28683074928720, SKU: "REU056", title: "16.9oz / 500ml", price: "20.50"},
        ]
      },
    },

    /** Product: "Matte Styling Paste" */
    {
      hairstyle: "MESSY", hairshine: "LOW", holdfactor: "MEDIUM",
      recommendation1: { title: "Matte Styling Paste", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/matte-styling-paste-3-38oz-100ml", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteStylingPaste.jpg?v=1578605343", selected: "REU067", 
        variants: [
          {id: 30274287927376, SKU: "REU067", title: "Matte Styling Paste - 3.38oz/100ml", price: "13.95"},
        ]
      },
    },
    {
      hairstyle: "POMPADOUR", hairshine: "LOW", holdfactor: "LIGHT",
      recommendation1: { title: "Matte Styling Paste", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/matte-styling-paste-3-38oz-100ml", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteStylingPaste.jpg?v=1578605343", selected: "REU067", 
        variants: [
          {id: 30274287927376, SKU: "REU067", title: "Matte Styling Paste - 3.38oz/100ml", price: "13.95"},
        ]
      },
    },
    {
      hairstyle: "SIDE PART", hairshine: "LOW", holdfactor: "LIGHT",
      recommendation1: { title: "Matte Styling Paste", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/matte-styling-paste-3-38oz-100ml", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteStylingPaste.jpg?v=1578605343", selected: "REU067", 
        variants: [
          {id: 30274287927376, SKU: "REU067", title: "Matte Styling Paste - 3.38oz/100ml", price: "13.95"},
        ]
      },
      recommendation2: { title: "Clay Spray", subtitle: "Clay Spray", url: "/products/reu074", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/ClaySpray_1296x_9bd269d3-6335-4141-962b-8464f675dba5.jpg", selected: "REU074", 
        variants: [
          {id: 32735586156624, SKU: "REU074", title: "Clay Spray", price: "20.00"},
        ]
      },
    },
    {
      hairstyle: "SLICK", hairshine: "LOW", holdfactor: "LIGHT",
      recommendation1: { title: "Matte Styling Paste", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/matte-styling-paste-3-38oz-100ml", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteStylingPaste.jpg?v=1578605343", selected: "REU067", 
        variants: [
          {id: 30274287927376, SKU: "REU067", title: "Matte Styling Paste - 3.38oz/100ml", price: "13.95"},
        ]
      },
    },
    {
      hairstyle: "SLICK", hairshine: "MEDIUM", holdfactor: "STRONG",
      recommendation1: { title: "Matte Styling Paste", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/matte-styling-paste-3-38oz-100ml", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteStylingPaste.jpg?v=1578605343", selected: "REU067", 
        variants: [
          {id: 30274287927376, SKU: "REU067", title: "Matte Styling Paste - 3.38oz/100ml", price: "13.95"},
        ]
      },
      recommendation2: { title: "Reuzel Pink Pomade", subtitle: "STRONG HOLD - MEDIUM SHINE - OIL BASED", url: "/products/pink-pomade-heavy-hold-medium-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/Reuzel__Pink_Pomade_4oz_113g.jpg?v=1578605116", selected: "REU003", 
        variants: [
          {id: 27861333016656, SKU: "REU008", title: "1.3oz/35g", price: "8.50"},
          {id: 27861333049424, SKU: "REU003", title: "4oz/113g", price: "17.00"},
          {id: 27861333082192, SKU: "REU009", title: "12oz/340g", price: "38.00"},
        ]
      },
    },
    {
      hairstyle: "SPIKEY", hairshine: "LOW", holdfactor: "LIGHT",
      recommendation1: { title: "Matte Styling Paste", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/matte-styling-paste-3-38oz-100ml", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteStylingPaste.jpg?v=1578605343", selected: "REU067", 
        variants: [
          {id: 30274287927376, SKU: "REU067", title: "Matte Styling Paste - 3.38oz/100ml", price: "13.95"},
        ]
      },
    },

    /** Product: "Reuzel Red Pomade" */
    {
      hairstyle: "CURLY", hairshine: "HIGH", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "POMPADOUR", hairshine: "HIGH", holdfactor: "LIGHT",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "SLICK", hairshine: "HIGH", holdfactor: "LIGHT",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "SLICK", hairshine: "HIGH", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "SIDE PART", hairshine: "HIGH", holdfactor: "LIGHT",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "SIDE PART", hairshine: "HIGH", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "TEXTURE", hairshine: "HIGH", holdfactor: "LIGHT",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "TEXTURE", hairshine: "HIGH", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "SPIKEY", hairshine: "HIGH", holdfactor: "LIGHT",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "SPIKEY", hairshine: "HIGH", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "MESSY", hairshine: "HIGH", holdfactor: "LIGHT",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "MESSY", hairshine: "HIGH", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "?", hairshine: "HIGH", holdfactor: "LIGHT",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },
    {
      hairstyle: "?", hairshine: "HIGH", holdfactor: "MEDIUM",
      recommendation1: { title: "Reuzel Red Pomade", subtitle: "MEDIUM HOLD - HIGH SHINE - WATER SOLUBLE", url: "/products/red-pomade-medium-hold-high-shine", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/WaterSolubleHighSheen.jpg?v=1578605", selected: "REU001", 
        variants: [
          {id: 27861330657360, SKU: "REU004", title: "1.3oz/35g", price: "8.00"},
          {id: 27861330690128, SKU: "REU001", title: "4oz/113g", price: "16.00"},
          {id: 27861330722896, SKU: "REU005", title: "12oz/340g", price: "36.00"},
        ]
      },
    },

    /** Product: "Spray Grooming Tonic" */
    {
      hairstyle: "TEXTURE", hairshine: "LOW", holdfactor: "LIGHT",
      recommendation1: { title: "Spray Grooming Tonic", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/spray-grooming-tonic", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/SprayGroomingTonic.jpg?v=1578605537", selected: "REU063", 
        variants: [
          {id: 28696575443024, SKU: "REU063", title: "12oz/355ml", price: "18.00"},
          {id: 31782310510672, SKU: "REU071", title: "3.38oz/100ml", price: "7.00"},
        ]
      },
    },
    {
      hairstyle: "LONG", hairshine: "MEDIUM", holdfactor: "LIGHT",
      recommendation1: { title: "Spray Grooming Tonic", subtitle: "LIGHT HOLD – LOW SHINE – WATER BASED", url: "/products/spray-grooming-tonic", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/SprayGroomingTonic.jpg?v=1578605537", selected: "REU063", 
        variants: [
          {id: 28696575443024, SKU: "REU063", title: "12oz/355ml", price: "18.00"},
          {id: 31782310510672, SKU: "REU071", title: "3.38oz/100ml", price: "7.00"},
        ]
      },
    },

    /** Product: "Surf Tonic" */
    {
      hairstyle: "CURLY", hairshine: "LOW", holdfactor: "LIGHT",
      recommendation1: { title: "Surf Tonic", subtitle: "LIGHT HOLD – MATTE FINISH – ADDS TEXTURE", url: "/products/surf-tonic", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/SurfTonic.jpg?v=1578605622", selected: "REU064", 
        variants: [
          {id: 28696560074832, SKU: "REU064", title: "11.83oz/350ml", price: "15.00"},
          {id: 31782269419600, SKU: "REU072", title: "3.38oz/100ml", price: "6.00"},
        ]
      },
    },
    {
      hairstyle: "TEXTURE", hairshine: "LOW", holdfactor: "MEDIUM",
      recommendation1: { title: "Surf Tonic", subtitle: "LIGHT HOLD – MATTE FINISH – ADDS TEXTURE", url: "/products/surf-tonic", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/SurfTonic.jpg?v=1578605622", selected: "REU064", 
        variants: [
          {id: 28696560074832, SKU: "REU064", title: "11.83oz/350ml", price: "15.00"},
          {id: 31782269419600, SKU: "REU072", title: "3.38oz/100ml", price: "6.00"},
        ]
      },
    },
    {
      hairstyle: "LONG", hairshine: "LOW", holdfactor: "LIGHT",
      recommendation1: { title: "Surf Tonic", subtitle: "LIGHT HOLD – MATTE FINISH – ADDS TEXTURE", url: "/products/surf-tonic", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/SurfTonic.jpg?v=1578605622", selected: "REU064", 
        variants: [
          {id: 28696560074832, SKU: "REU064", title: "11.83oz/350ml", price: "15.00"},
          {id: 31782269419600, SKU: "REU072", title: "3.38oz/100ml", price: "6.00"},
        ]
      },
      recommendation2: { title: "Matte Texture Powder", subtitle: "VOLUME - TEXTURE - NO SHINE", url: "/products/matte-texture-powder-0-53oz-15g", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/MatteTexturePowder.jpg?v=1578605375", selected: "REU068", 
        variants: [
          {id: 30274290712656, SKU: "REU068", title: "Matte Texture Powder - 0.53oz/15g", price: "18.00"},
        ]
      },
    },
    {
      hairstyle: "MESSY", hairshine: "LOW", holdfactor: "LIGHT",
      recommendation1: { title: "Surf Tonic", subtitle: "LIGHT HOLD – MATTE FINISH – ADDS TEXTURE", url: "/products/surf-tonic", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/SurfTonic.jpg?v=1578605622", selected: "REU064", 
        variants: [
          {id: 28696560074832, SKU: "REU064", title: "11.83oz/350ml", price: "15.00"},
          {id: 31782269419600, SKU: "REU072", title: "3.38oz/100ml", price: "6.00"},
        ]
      },
    },
    {
      hairstyle: "?", hairshine: "LOW", holdfactor: "LIGHT",
      recommendation1: { title: "Surf Tonic", subtitle: "LIGHT HOLD – MATTE FINISH – ADDS TEXTURE", url: "/products/surf-tonic", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/SurfTonic.jpg?v=1578605622", selected: "REU064", 
        variants: [
          {id: 28696560074832, SKU: "REU064", title: "11.83oz/350ml", price: "15.00"},
          {id: 31782269419600, SKU: "REU072", title: "3.38oz/100ml", price: "6.00"},
        ]
      },
      recommendation2: { title: "Grooming Cream", subtitle: "Light Hold Low Shine Water Soluble", url: "/products/reu066", image: "https://cdn.shopify.com/s/files/1/0086/0969/3776/products/GroomingCream.jpg?v=1578605175", selected: "REU066", 
        variants: [
          {id: 30274287796304, SKU: "REU066", title: "REU066", price: "12.95"},
        ]
      },
    },
  ];

  RecTool.Utils = {
    getRecommends: function() {
      // Open "Product Recommender" block
      $recommender.find('.recommender-product').removeClass('is-collapsed').addClass('is-active');

      if ( ! RecTool.skus.length ) { 
        return;
      }

      var recommendation1;
      var recommendation2;
      $.each(RecTool.skus, function( i, obj ){
        if ( obj.hairstyle == hairstyle.toUpperCase() && obj.hairshine == hairshine.toUpperCase() && obj.holdfactor == holdfactor.toUpperCase() ) {
          if ( typeof obj.recommendation1 !== 'undefined' ) {
            recommendation1 = obj.recommendation1;
          }

          if ( typeof obj.recommendation2 !== 'undefined' ) {
            recommendation2 = obj.recommendation2;
          }

          return;
        }
      });

      // Add recommended products to block
      $product_wrapper     = $recommender.find('.recommender-product .product-details');
      $product_wrapper_sec = $recommender.find('.recommender-product .product-details--secondary');

      if ( $('.recommender-slider').hasClass('slick-initialized') ) { 
        $('.recommender-slider').slick('unslick');
      }
      $product_wrapper.empty();
      $product_wrapper_sec.empty();

      if ( typeof recommendation1 === 'undefined' && typeof recommendation2 === 'undefined' ) {
        $product_wrapper.append('<div>No Products Found</div>');
      } else {
        if ( typeof recommendation1 !== 'undefined' ) {
          RecTool.Utils.addProductDetails($product_wrapper, recommendation1);
        }

        if ( typeof recommendation2 !== 'undefined' ) {
          RecTool.Utils.addProductDetails($product_wrapper_sec, recommendation2);

          $('.recommender-slider').slick({ 
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: '.slider-arrows',
          });
        }

        RecTool.Utils.goToBottom($recommender.find('.recommender-product'));
      }
    },
    isReadyforRecommend: function() { 
      if ( !hairstyle || !hairshine || !holdfactor ) { 
        return false;
      }

      return true;
    },
    addProductDetails: function($wrapper, data) { 
      var html = ``;

      // console.log(data);

      var data_price      = data.variants[0].price;
      var data_variant_id = 0;

      $.each(data.variants, function( i, obj ){
        if ( obj.SKU == data.selected ) {
          data_price      = obj.price;
          data_variant_id = obj.id;

          return;
        }
      });

      html += `<div class="row"><div class="col-12 col-sm-4"><form method="post" action="/cart/add" enctype="multipart/form-data" class="product-form">`;
      html += `<div class="recommender-product--title h3">` + data.title + `</div>`;
      html += `<div class="recommender-product--subtitle body1">` + data.subtitle + `</div>`;
      html += `<div class="recommender-product--price h3">$` + data_price + `</div>`;
      // html += `<input type="hidden" name="id" value="` + data_variant_id + `" />`;

      html += `<div class="recommender-product--variants template-product">`;
      html += `<div class="pdp-single-wrapper">`;
      html += `<label>Size: </label>`;
      html += `<select name="id">`;
      $.each(data.variants, function( i, obj ){
        // var is_checked = "";
        var is_selected = "";
        if ( obj.SKU == data.selected ) {
          // is_checked = `checked`;
          is_selected = `selected="selected"`;
        }

        html += `<option value="${obj.id}" data-price="${obj.price}" ${is_selected}> ${obj.title} </option>`;

        // html += `<div class="recommender-product--option">`;
        // html += `<input type="radio" name="id" value="` + obj.id + `" ` + is_checked + `/>`;
        // html += `<label>` + obj.title + `</label>`;
        // html += `</div>`;
      });
      html += `</select>`;
      html += `</div>`;
      html += `</div>`;

      html += `
        <div class="recommender-product--addtocart">
          <div class="recommender-product--qty qty-wrapper">
            <div class="qty-minus qty-decrease"></div>
            <input type="number" name="quantity" value="1" class="body1" />
            <div class="qty-plus qty-increase"></div>
          </div>
          <button type="submit" class="button cta large-button recommender-product--btn recommender-product--add">Add To Cart</button>
        </div>
      `;
      html += `<a href="` + data.url + `?variant=` + data_variant_id + `" class="recommender-product--btn recommender-product--learn button cta red-button">Learn More</a>`;
      html += `</form></div><div class="col-12 col-sm-8">`;
      html += `<img src="` + data.image + `" class="recommender-product--image" alt="Recommended Product"></div></div>`;


      $wrapper.append(html);
    },
    goToBottom: function($ele) { 
      /*
      var $container = $recommender.find('.recommender-content');
      var currentTop = $container.scrollTop();
      var offset_y = $ele.offset().top - $recommender.find('.recommender-content').offset().top;

      $container.animate({
        scrollTop: currentTop + offset_y
      }, 500);
      */

      var offsetTop      = $ele.offset().top;
      var headerHeight   = $('.header-wrap header').outerHeight();
      var announceHeight = 0;
      if ( $('.component-announcement-bar').length ) { 
        announceHeight = $('.component-announcement-bar').outerHeight();
      }

      offsetTop = offsetTop - headerHeight - announceHeight - 80;
      if ( offsetTop < 0 ) { 
        offsetTop = 0;
      }

      $('html, body').animate({ 
        // scrollTop: offsetTop
      }, 500);
    }
  };

  RecTool.Cart = {
    cartUpdateCallback: function(cart) { 
      $('body').find('.js-drawer-open-CartDrawer').trigger('click');
      console.log(cart);
      
      return;
    },
    itemAddedCallback: function(product) { 
      ShopifyAPI.getCart(RecTool.Cart.cartUpdateCallback);
    },
    itemErrorCallback: function(XMLHttpRequest, textStatus) { 
      /**
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      $addToCart.removeClass('is-adding is-added');

      if (!!data.message) {
        if (data.status == 422) {
          $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
        }
      }
      */
    }
  };

  var bindUIActions = function () {
    $('body')

    /** Toggle Recommender Tool sidebar */
    .on('click', '.recommender-toggle, .recommender-panel--close', function(e) { 
      $recommender.toggleClass('toggle-opened');

      $('html').toggleClass('recommender-tool-opened');
      $( ".recommender-swatch label" ).trigger( "click" );
    })

    /** Click "Swatch" tab */
    .on('click', '.recommender-swatch label', function(e) { 
      var swatch_option = $('[name="swatch-type"]').val();

      // reset all settings
      $recommender.find('.recommender-block').removeClass('is-active');
      $recommender.find('.recommender-block').removeClass('is-collapsed');

      $recommender.find('.recommender-block input').prop('checked', false);
      hairstyle = hairshine = holdfactor = '';

      if ( 'Hair' == swatch_option ) { 
        $recommender.find('.recommender-hairstyle').addClass('is-active');
      } else if ( 'Beard' == swatch_option ) { 
        $recommender.find('.recommender-description').addClass('is-active');
      } else if ( 'Skin' == swatch_option ) { 
        $recommender.find('.recommender-description').addClass('is-active');
      }

      RecTool.Utils.goToBottom($('.recommender-block.is-active'));
      return;
    })

    /** Change event on Hair Swatch options */
    .on('change', '.recommender-block input', function(e) { 
      var $this = $(this),
          $block = $this.closest('.recommender-block'),
          option_val = $(this).val();

      if ( ! option_val ) { 
        return;
      }

      $block.find('.recommender-block--title .selected').text(option_val);
      $block.removeClass('is-active').addClass('is-collapsed');

      /** Hair Style selector */
      if ( $block.hasClass('recommender-hairstyle') ) { 
        hairstyle = option_val;

        if ( RecTool.Utils.isReadyforRecommend() ) { 
          RecTool.Utils.getRecommends();
        } else { 
          $recommender.find('.recommender-hairshine').removeClass('is-collapsed').addClass('is-active');
          RecTool.Utils.goToBottom($('.recommender-block.is-active'));
        }
        return;
      }

      /** Hair Shine selector */
      if ( $block.hasClass('recommender-hairshine') ) { 
        hairshine = option_val;

        if ( RecTool.Utils.isReadyforRecommend() ) { 
          RecTool.Utils.getRecommends();
        } else { 
          $recommender.find('.recommender-holdfactor').removeClass('is-collapsed').addClass('is-active');
          RecTool.Utils.goToBottom($('.recommender-block.is-active'));
        }
        return;
      }

      /** Hair Hold selector */
      if ( $block.hasClass('recommender-holdfactor') ) { 
        holdfactor = option_val;

        if ( RecTool.Utils.isReadyforRecommend() ) { 
          RecTool.Utils.getRecommends();
        }

        return;
      }
    })

    /** Go to Option Select Box on title click */
    .on('click', '.recommender-block .recommender-block--title', function(e) {
      $recommender.find('.recommender-block.is-active').removeClass('is-active').addClass('is-collapsed');
      $(this).closest('.recommender-block').removeClass('is-collapsed').addClass('is-active');

      RecTool.Utils.goToBottom($('.recommender-block.is-active'));
    })

    /** Quantity Adjust action */
    .on('click', '.qty-minus', function() { 
      var $parent = $(this).parent();
      var current_val = parseInt($parent.find('input').val());

      if ( current_val < 2 ) {
        $parent.find('input').val(1);
      }
      else {
        $parent.find('input').val(current_val - 1);
      }
    })

    .on('click', '.qty-plus', function() { 
      var $parent = $(this).parent();

      $parent.find('input').val(parseInt($parent.find('input').val()) + 1);
    })

    /** Update Recommended Product's Price on Variant Selection*/
    .on('change', '.recommender-product--variants select', function() { 
      var price = $(this).find('option:selected').data('price');
      $(this).closest('form').find('.recommender-product--price').html(`$${price}`);
    })

    /** Add to Cart ajax action */
    .on('submit', '.recommender-product form', function(e) { 
      e.preventDefault();

      $('body').find('.recommender-panel--close').trigger('click');

      // ShopifyAPI.addItemFromForm(e.target, RecTool.Cart.itemAddedCallback, RecTool.Cart.itemErrorCallback);

      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(this).serialize(),
        dataType: 'json',
        success: function(line_item) {
          goCart.reloadAjaxContent();
        },
        error: function(XMLHttpRequest, textStatus) {
          
        }
      };
      jQuery.ajax(params);

    });

    $('html').on('click', function(e) { 
      if ( ! $(e.target).parents('.product-recommender--wrapper').length ) { 
        $recommender.removeClass('toggle-opened');
        $('html').removeClass('recommender-tool-opened');
      }
    })
  };

  RecTool.init = function () {
    bindUIActions();
  };

  RecTool.init();
})(window.RecTool = window.RecTool || {}, jQuery);